// Glob eager de toutes les icônes SVG (chemin relatif à shared/ → static/icons/ à la racine).
// (nouveaux SVG ajoutés à chaud : Vite re-scanne le dossier au re-transform de ce fichier)
const svgModules = import.meta.glob(
	'../static/icons/*.svg',
	{ eager: true, query: '?raw', import: 'default' }
) as Record<string, string>;

const iconRegistry = new Map<string, string>();
const iconDataUrls = new Map<string, string>();

for (const [path, svg] of Object.entries(svgModules))
{
	const name = path.split('/').pop()!.replace('.svg', '');
	iconRegistry.set(name, svg);
	iconDataUrls.set(name, 'data:image/svg+xml,' + encodeURIComponent(svg));
}

export { iconDataUrls };
export default iconRegistry;
